






































































































































































































































































































































































































































































































































































































































































































































































































import MultiSelect from '@/components/MultiSelect.vue';
import ResultView from '@/components/ResultView.vue';
import RevaluationQueue from '@/components/RevaluationQueue.vue';
import RevaluationQuotas from '@/components/RevaluationQuotas.vue';
import {TableHeaders} from '@/interfaces/components-data';
import {GlobalSettingsData, SelectBox, SelectMarket} from '@/interfaces/global-data';
import {
  AdditionalRole,
  GetTaskInfo,
  isTaskInBackgroundGeneratableTypesAndStatuses,
  ResultTableHeaders,
  TaskAndFile,
  TaskData,
  TaskInfoFilterType,
  TaskParams,
  TaskStatus,
  TaskType,
  taskTypesRequiresConfirmation,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import { localizeTaskType, localizeTaskStatus } from '@/utils/backendValueLocalizer';
import Http from '@/mixins/http';
import moment from 'moment';
import {Component, Mixins} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';
import TaskStatusMixin from '../mixins/task-status';
import CollapseCard from "@/components/UI/CollapseCard.vue"
import Card from '@/components/UI/Card.vue';
import IconButton from '@/components/UI/IconButton.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import {BvModalEvent} from "bootstrap-vue";

interface ITableFilterValues {
    taskUpdateDateFilter: string | null,
    taskIdsFilter: number[],
}

@Component({
    components: {
        RevaluationQuotas,
        RevaluationQueue,
        MultiSelect,
        ResultView,
        vSelect,
        LocalData,
        CollapseCard,
        Card,
        IconButton,
        SwitchWithLabel,
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD/MM/YYYY HH:mm:ss');
                }
            },
        },
        methods: {
            replaceDecimalSubStrFormatter(value) {
                if (value == null) {
                    return null
                } else {
                    const result = parseFloat(value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, '$1').replace(',', '.'));
                    return String(result).substring(0, 6)
                }
            },
        },
    })
    export default class Revaluation extends Mixins(LocalData, Toast, Http, TaskStatusMixin) {
        defaultIntSelectBox: Array<SelectBox<number>> = [{value: -1, label: this.$t('regular.common.all') as string}];
        foundedApprovedReports: boolean = false
        showQuotas: boolean = true;
        waitingToBeSentToFtp = false;
        selectedReportsArray: number[] = [];
        updatedDateRange: string[] = [];
        defaultFilterValue = {value: -1, label: this.$t('regular.common.all') as string};
        secondDefaultFilterValue = {value: -2, label: this.$t('regular.common.notSelected') as string};
        defaultMultipleValue = [this.defaultFilterValue, this.secondDefaultFilterValue];
        globalSettings: GlobalSettingsData = this.getGlobalSettingsDefaultData();

        // Loading states for download buttons
        downloadingFiles: boolean = false;
        downloadingTaskIds: Set<number> = new Set();

        selectMarket: SelectBox<number> = this.defaultFilterValue;
        newSelectMarket: number = this.defaultFilterValue.value;
        items: Array<SelectBox<number>> = [];

        categoryOptions: Array<SelectBox<number>> = [];
        categoryOfProduct: SelectBox<number> = this.defaultFilterValue;
        newCategoryOfProduct: number = this.defaultFilterValue.value;

        subCategoryOptions: Array<SelectBox<number>> = this.defaultMultipleValue;
        subCategoryOfProduct: number[] = [];

        selectGroup: SelectBox<number> = this.defaultFilterValue;
        newSelectGroup: number = this.defaultFilterValue.value;
        groupOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

        selectFormat: SelectBox<number> = this.defaultFilterValue;
        newSelectFormat: number = this.defaultFilterValue.value;
        formatOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

        selectRegion: number[] = [];
        regionOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

        selectCluster: SelectBox<number> = this.defaultFilterValue;
        newSelectCluster: number = this.defaultFilterValue.value
        clusterOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

        selectReportType: SelectBox<TaskType | null> = {value: null, label: this.$t('regular.common.all') as string};
        newSelectReportType: TaskType | null = null;
        usersFioList: Array<SelectBox<string>> = [];
        selectUserFio: SelectBox<string> = {value: 'All', label: this.$t('regular.common.all') as string};
        newSelectUserFio: string = 'All';

        table: TaskData[] = [];
        tradingsList: Array<SelectBox<number>> = [];
        selectedTradings: SelectMarket[] = [];
        showUploadPricingModal: boolean = false;
        showMajorPriceDiffModal: boolean = false;
        showUploadSalesModal: boolean = false;
        showSalesConfirmModal: boolean = false;
        waitingToBeSentSalesToFtp = false;

        reportList: Array<SelectBox<TaskType | null>> = [
            {value: null, label: this.$t('regular.common.all') as string},
            ...taskTypesRequiresConfirmation,
        ];

        selectedStatusesFilter: TaskStatus[] = [TaskStatus.ONAPPROVAL, TaskStatus.SENT_TO_FINAL_APPROVAL];
        statusFilterCheckboxOptions: Array<{ label: string; value: TaskStatus }> = [
          {value: TaskStatus.ONAPPROVAL, label: this.$t('regular.statuses.pendingApproval') as string},
          {value: TaskStatus.SENT_TO_FINAL_APPROVAL, label: this.$t('regular.statuses.sentForFinalApproval') as string},
          {value: TaskStatus.APPROVED, label: this.$t('regular.statuses.approved') as string},
          {value: TaskStatus.PARTIALLY_APPROVED, label: this.$t('regular.statuses.partiallyApproved') as string},
          {value: TaskStatus.PARTIALLY_REJECTED, label: this.$t('regular.statuses.partiallyRejected') as string},
        ];

        tableFilterValues: ITableFilterValues = {
            taskUpdateDateFilter: null,
            taskIdsFilter: [],
        };
        filterDropdownsRange: any = {
            from: {},
            to: {},
        };
        tableFilterOptions: any = {};
        filterAllCheckboxCheckedState: any = {};
        taskIdsCommonCount: number = 0;
        taskIdsDisplayedCount: number = 0;
        taskIdsMaxViewCount: number = 50;

        tableFields: TableHeaders[] = [
            {key: 'selected', label: ''},
            {key: 'id', label: '№'},
            {key: 'message', label: this.$t('regular.columns.status') as string},
            {key: 'updated', label: this.$t('regular.columns.changeTime') as string},
            {key: 'userFio', label: this.$t('regular.columns.user') as string},
            {key: 'tradingNetworks.tradingName', label: this.$t('regular.columns.company') as string},
            {key: 'type', label: this.$t('regular.columns.type') as string},
            {key: 'group', label: this.$t('regular.columns.group') as string},
            {key: 'category', label: this.$t('regular.columns.category') as string},
            {key: 'subcategories', label: this.$t('regular.columns.subcategories') as string},
            {key: 'format', label: this.$t('regular.columns.format') as string},
            {key: 'region', label: this.$t('regular.columns.region') as string},
            {key: 'cluster', label: this.$t('regular.columns.cluster') as string},
            {key: 'fileResult', label: this.$t('regular.columns.actions') as string},
        ];

        newTableFields: any[] = [
            {dataIndex: 'selected', title: '✔', scopedSlots: { customRender: 'selected' }, width: 50, fixed: 'left'},
            {dataIndex: 'fileResult', title: this.$t('regular.columns.actions') as string, scopedSlots: { customRender: 'actions' }, width: 200, ellipsis: true, stickyColumn: true, fixed: 'left'},
            {
                dataIndex: 'id',
                title: '№',
                filterModelKey: 'taskIdsFilter',
                filterOptionsKey: 'taskIds',
                showRange: true,
                scopedSlots: {
                    filterDropdown: 'filterCheckboxes',
                    filterIcon: "filterIcon",
                },
                width: 100,
            },
            {dataIndex: 'message', title: this.$t('regular.columns.status') as string, width: 200, scopedSlots: { customRender: 'message', filterDropdown: 'messageFilter', filterIcon: "messageFilterIcon" }, filters: []},
            {
                dataIndex: 'updated',
                title: this.$t('regular.columns.changeTime') as string,
                filterModelKey: 'taskUpdateDateFilter',
                scopedSlots: {
                    customRender: 'updated',
                    filterDropdown: 'filterDatepicker',
                    filterIcon: "filterIcon",
                },
                width: 200,
            },
            {dataIndex: 'userFio', title: this.$t('regular.columns.user') as string, width: 150, scopedSlots: { filterDropdown: 'userFioFilter', filterIcon: "userFioFilterIcon" }, filters: [], ellipsis: true},
            {dataIndex: 'tradingNetworks.tradingName', title: this.$t('regular.columns.company') as string, width: 150, scopedSlots: { filterDropdown: 'tradingNetworks.tradingNameFilter', filterIcon: "tradingNetworks.tradingNameFilterIcon" }, filters: [], ellipsis: true},
            {dataIndex: 'type', title: this.$t('regular.columns.type') as string, width: 170, scopedSlots: { customRender: 'type', filterDropdown: 'typeFilter', filterIcon: "typeFilterIcon" }, filters: [], ellipsis: true},
            {dataIndex: 'group', title: this.$t('regular.columns.group') as string, width: 300, scopedSlots: { filterDropdown: 'groupFilter', filterIcon: "groupFilterIcon" }, filters: [], ellipsis: true},
            {dataIndex: 'category', title: this.$t('regular.columns.category') as string, width: 200, scopedSlots: { filterDropdown: 'categoryFilter', filterIcon: "categoryFilterIcon" }, filters: [], ellipsis: true},
            {dataIndex: 'subcategories', title: this.$t('regular.columns.subcategories') as string, width: 250, scopedSlots: { filterDropdown: 'subcategoriesFilter', filterIcon: "subcategoriesFilterIcon" }, filters: [], ellipsis: true},
            {dataIndex: 'format', title: this.$t('regular.columns.format') as string, width: 100, scopedSlots: { filterDropdown: 'formatFilter', filterIcon: "formatFilterIcon" }, filters: [], ellipsis: true},
            {dataIndex: 'region', title: this.$t('regular.columns.region') as string, width: 150, scopedSlots: { filterDropdown: 'regionFilter', filterIcon: "regionFilterIcon" }, filters: [], ellipsis: true},
            {dataIndex: 'cluster', title: this.$t('regular.columns.cluster') as string, width: 150, scopedSlots: { filterDropdown: 'clusterFilter', filterIcon: "clusterFilterIcon" }, filters: [], ellipsis: true},
        ];

        pagination: any = {
            pageSize: 20,
            current: 1
        };

        loadingTable = true;

        taskToView: TaskAndFile | null = null;
        packageSubtask: TaskAndFile | null = null;
        perPage: number = 20;
        currentPage: number = 1;
        totalRows: number = 0;
        showDeleteSingleReportModal: boolean = false;
        showRejectSingleReportModal: boolean = false;
        showApproveSingleReportModal: boolean = false;
        showApproveCheckedReportsModal: boolean = false;
        taskIdForDelete: number = -1;
        taskIdForReject: number = -1;
        taskIdForApprove: number = -1;
        currentMainTab: string = "listViewTab"

        refreshTableIntervalId: number = 0;

        private canBeShowTypes = [
            TaskType.PACKAGE_REGULAR,
            TaskType.PACKAGE_SCHEDULE,
            TaskType.REGULAR,
            TaskType.PACKAGE_GENERAL,
            TaskType.PACKAGE_SCENARIO,
            TaskType.PACKAGE_GENERAL_SCENARIO,
            TaskType.PACKAGE_EVENTS,
            TaskType.PACKAGE_EVENTS_GENERAL,
            TaskType.REGULAR_PRICE_EXP,
            TaskType.SCHEDULED_PRICE_EXP,
        ];

        mounted() {
            EventBus.$on('calc', this.onCalcEventReceived);
            EventBus.$on('packageSubTaskView', this.onPackageSubTaskViewEventReceived)
            this.loadTasksMarkets();
            this.checkApprovedReports();
            this.loadAllTradingNames();
            this.fetchGlobalSettingsData();

            if (this.isFinalApprover() && !this.isAdminAdmin()) {
                this.selectedStatusesFilter = [TaskStatus.SENT_TO_FINAL_APPROVAL];
            }

            const pager = { ...this.pagination };
            pager.current = 1;
            this.pagination = pager;
            this.fetchList({
                currentPage: this.pagination.current,
                perPage: this.pagination.pageSize,
            }, () => {})

            this.startAutoRefreshTable()
        }

        beforeDestroy() {
            EventBus.$off('calc', this.onCalcEventReceived);
            EventBus.$off('packageSubTaskView', this.onPackageSubTaskViewEventReceived)
            clearTimeout(this.refreshTableIntervalId)
        }

        onTableChange(pagination: any) {
            this.loadingTable = true;
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
            this.fetchList({
                currentPage: pagination.current,
                perPage: pagination.pageSize,
            }, () => {});
        }

        onCalcEventReceived(data: TaskData) {
            this.updateTaskRowStatus(data);
        }

        onPackageSubTaskViewEventReceived(task: ResultTableHeaders) {
            this.selectPackageResult(task);
        }

        onApproveCheckedReports(taskIds: number[]) {
          if (!taskIds.length) {
            return;
          }
          const ids = [...taskIds];
          this.selectedReportsArray = [];
          this.cancelCheckedReports();

          if (this.isTwoStepApprovalEnabled) {
            this.sendTaskToFinalApproval(ids);
          } else {
            this.cancelCheckedReports();
            this.showApprovedCheckedReports(ids);
            return;
          }
        }

        created() {
            if (this.accessToModule()) {
                this.$router.replace('/calc');
            }
        }

        accessToModule(): boolean {
            return this.$disallowedModules.includes('revaluation')
        }

        updateTaskRowStatus(data: TaskData) {
            const index = this.table.findIndex((item) => {
                return item.id === data.id;
            });
            if (index === -1) {
                this.table = [data, ...this.table];
                return;
            }
            this.table[index].message = data.message;
            this.table[index].updated = data.updated;
            this.table[index].fileResult = data.fileResult;
            this.table[index].progress = data.progress;
            this.table[index].status = data.status;
            // Костыль - обновляем страницу отчетов, т.к. Пакетный общий отчет создается с пустой группой, категорией и тд и только потом они подтягиваются в виде списка при загрузке страницы
            if (data.type === 'Пакетный общий' && data.status === 'WriteToFileComplete') {
                this.refreshTable();
            }
        }

        onMainTabsClicked(key:string) {
            this.currentMainTab = key
        }

        updateSelectMarket(market: number) {
          this.newSelectMarket = market
          this.resetData(null);
          if (LocalData.zeroToNull(market) != null) {
            this.loadReportListFilterOptions()
          }
        }

        showProgressBar(status: string): boolean {
            return status === 'Calculating'
                || status === 'CalculatingComplete'
                || status === 'WriteToFile';
        }

        showCompleteMessage(status: string): boolean {
            return status === 'WriteToFileComplete';
        }

        beforeRejectFileDialog(taskId: number) {
            this.showRejectSingleReportModal = true
            this.taskIdForReject = taskId;
        }

        beforeApproveFileDialog(taskId: number, taskStatus: TaskStatus) {
            if (this.globalSettings.useTwoStepRevaluationApproval && taskStatus != TaskStatus.SENT_TO_FINAL_APPROVAL) {
              this.sendTaskToFinalApproval([taskId]);
              return
            }
            this.showApproveSingleReportModal = true
            this.taskIdForApprove = taskId;
        }

        beforeFinalApproveReport(taskId: number) {
            this.showApproveSingleReportModal = true
            this.taskIdForApprove = taskId;
        }

        showDeleteFileDialog(taskId: number) {
            this.deleteTask([taskId]);
        }

        showRejectFileDialog(taskId: number) {
            this.rejectTask([taskId]);
        }

        showApproveFileDialog(taskId: number) {
            this.approveTask([taskId]);
        }

        showDeleteCheckedReports(taskIds: number[]) {
            this.deleteTask(taskIds);
            this.selectedReportsArray = [];
        }

        showRejectTaskButton(task: TaskData): boolean {
          const baseAllowed =
              task.status !== TaskStatus.APPROVED &&
              task.status !== TaskStatus.REJECTED;

          if (!baseAllowed) {
            return false;
          }

          // если двухшаговое согласование выключено — всё как раньше
          if (!this.globalSettings.useTwoStepRevaluationApproval) {
            return baseAllowed;
          }

          // если включено и это финальный этап — проверяем роль
          if (task.status === TaskStatus.SENT_TO_FINAL_APPROVAL) {
            return this.isAdminAdmin() || this.isFinalApprover();
          }

          // остальные статусы — старое поведение
          return baseAllowed;
        }

        showDownloadFinalReportButton(task: TaskData): boolean {
          return task.status == TaskStatus.APPROVED && !!task.fileForRevaluationResult
        }

        showRejectCheckedReports(taskIds: number[]) {
            this.rejectTask(taskIds);
        }

        showApprovedCheckedReports(taskIds: number[]) {
            this.approveTask(taskIds);
        }

        openCheckedReportsApproveModal() {
          this.showApproveCheckedReportsModal = true
        }

        private taskTypeLabelMap: Record<string, string> = {
            [TaskType.REGULAR]: 'regular.taskTypes.regular',
            [TaskType.PACKAGE_REGULAR]: 'regular.taskTypes.package',
            [TaskType.PACKAGE_GENERAL]: 'regular.taskTypes.packageGeneral',
            [TaskType.PACKAGE_GENERAL_KVI_CARTS]: 'regular.taskTypes.packageByBasket',
            [TaskType.PACKAGE_GENERAL_KVI_RECOMMENDS]: 'regular.taskTypes.packageKviSearch',
            [TaskType.PACKAGE_PROMOTION]: 'regular.taskTypes.packagePromo',
            [TaskType.PACKAGE_GENERAL_PROMOTION]: 'regular.taskTypes.packageGeneralPromo',
            [TaskType.PACKAGE_SCHEDULE]: 'regular.taskTypes.scheduled',
            [TaskType.BRUT_FORCE]: 'regular.statuses.paramSearch',
            [TaskType.SEARCH_KVI]: 'regular.taskTypes.kviSearch',
            [TaskType.PROMO]: 'regular.columns.promo',
            [TaskType.PACKAGE_EVENTS]: 'regular.taskTypes.eventCalc',
            [TaskType.PACKAGE_EVENTS_GENERAL]: 'regular.taskTypes.eventCalcGeneral',
            [TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS]: 'regular.columns.promoRecommendations',
            [TaskType.PACKAGE_SCENARIO]: 'regular.taskTypes.scenario',
            [TaskType.PACKAGE_FIXED_PRICE]: 'regular.taskTypes.packageFixed',
            [TaskType.PACKAGE_GENERAL_FIXED_PRICE]: 'regular.taskTypes.packageGeneralFixed',
            [TaskType.REGULAR_PRICE_EXP]: 'regular.taskTypes.regularCe',
            [TaskType.SCHEDULED_PRICE_EXP]: 'regular.taskTypes.scheduledCe',
            [TaskType.SALES]: 'regular.taskTypes.sales',
            [TaskType.PACKAGE_SALES]: 'regular.taskTypes.packageSales',
            [TaskType.PACKAGE_GENERAL_SALES]: 'regular.taskTypes.packageGeneralSales',
            [TaskType.PACKAGE_AGGREGATE_SALES]: 'regular.taskTypes.packageAggregateSales',
            [TaskType.PACKAGE_GENERAL_AGGREGATE_SALES]: 'regular.taskTypes.packageGeneralAggregateSales',
            [TaskType.PACKAGE_GENERAL_PROMO]: 'regular.taskTypes.packageGeneralPromoCalc',
            [TaskType.PACKAGE_GENERAL_SCENARIO]: 'regular.taskTypes.packageGeneralScenario',
            [TaskType.PACKAGE_KVI_CARTS]: 'regular.taskTypes.packageKviCarts',
            [TaskType.PACKAGE_KVI_RECOMMENDS]: 'regular.taskTypes.packageKviRecommends',
            [TaskType.PACKAGE_PROMO]: 'regular.taskTypes.packagePromoCalc',
            [TaskType.PACKAGE_PROMO_RECOMMENDS]: 'regular.taskTypes.packagePromoRecommends',
        };

        getTaskTypeLabel(typeValue: string): string {
            return localizeTaskType(typeValue);
        }

        getTaskStatusLabel(status: string): string {
            return localizeTaskStatus(status);
        }

        showGenerateReportButton(task: TaskData): boolean {
          const isTaskReadyToBeGenerated =
              isTaskInBackgroundGeneratableTypesAndStatuses(task.typeMachine, task.status)

          return !task.fileResult.length && isTaskReadyToBeGenerated
        }

        recalculateGeneralTask(generalTaskId: number) {
            this.httpRecalculateGeneralTask(generalTaskId)
                .then((result) => {
                    this.showInfo(this.$t('regular.notifications.reportRecalculating') as string + generalTaskId);
                    this.handleFilter();

                })
                .catch(() => {
                    this.showError(this.$t('regular.errors.unexpectedRecalcError') as string);
                });
        }

        approveCheckedReports() {

        }

        onApprove() {
            this.showApproveFileDialog(this.taskIdForApprove)
            this.showApproveSingleReportModal = false
        }

        onHide() {
            this.cancelApprove()
        }

        onCheckedReportsHide(): void {
          this.cancelCheckedReports();
        }

        cancelApprove() {
            this.showApproveSingleReportModal = false
        }

        cancelCheckedReports(): void {
          this.showApproveCheckedReportsModal = false;
        }

        handleFilter() {
            this.loadingTable = true;
            const pager = { ...this.pagination };
            pager.current = 1;
            this.pagination = pager;
            this.fetchList({
                currentPage: this.pagination.current,
                perPage: this.pagination.pageSize,
            }, () => {})
        }

        generateReport(task: TaskData) {
          console.log("task", task)
          this.httpStartGeneratingReport(task.id)
              .then(() => {
                task.status = TaskStatus.WRITETOFILE
                this.refreshTable()
              })
        }

        canBeShowApprovedCheckedReports(taskIds: number[]): boolean {
          return taskIds.length === 0;
        }

        isFinalApproveDisabled(taskIds: number[]): boolean {
          if (!this.isTwoStepApprovalEnabled) {
            return true;
          }

          return taskIds.length === 0;
        }

        downloadFinalReportFile(task: TaskData) {
          this.httpDownloadFinalReportFile(task.id, task.fileForRevaluationResult)
        }

        downloadFile(taskId: number, file: string) {
            this.downloadingTaskIds.add(taskId);
            this.$http.get('/api/task/result', {
                method: 'GET',
                responseType: 'blob',
                params: {
                    taskId,
                },
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.downloadReportFailed') as string);
                })
                .finally(() => {
                    this.downloadingTaskIds.delete(taskId);
                });
        }

        downloadFiles(taskIds: number[]) {
            this.downloadingFiles = true;

            const downloadPromises = taskIds.map((id) => {
                const tableRow = this.table.find((item) => {
                    return item.id === id
                });
                return this.$http.get('/api/task/result', {
                    method: 'GET',
                    responseType: 'blob',
                    params: {
                        taskId: id,
                    },
                })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        // tslint:disable-next-line: no-non-null-assertion
                        link.setAttribute('download', tableRow!!.fileResult);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch((e) => {
                        this.showError(this.$t('regular.errors.downloadReportFailed') as string);
                    });
            });

            Promise.all(downloadPromises)
                .finally(() => {
                    this.downloadingFiles = false;
                });
        }

        deleteTask(taskIds: number[]) {
            this.$http.post('/api/task/delete', taskIds)
                .then(() => {
                    (this.$refs.tasksTable as any).$forceUpdate();
                    taskIds.forEach((id) => {
                        const index = this.table.findIndex((item) => {
                            return item.id === id
                        });
                        if (index !== -1) {
                            this.table.splice(index, 1);
                        }
                    });
                    this.checkApprovedReports();
                })
                .catch((err) => {
                    this.showError(this.$t('regular.errors.deleteReportFailed') as string);
                });
        }

        rejectTask(taskIds: number[]) {
            this.httpRejectTask(taskIds)
                .then((r) => {
                    this.checkApprovedReports();
                    if (taskIds.length > 1) {
                      this.selectedReportsArray = [];
                      this.showInfo(this.$t('regular.notifications.reportsRejected') as string);
                    }
                    else {
                      this.showInfo(this.$t('regular.notifications.reportRejected') as string);
                    }
                    this.fetchList({
                        currentPage: this.pagination.current,
                        perPage: this.pagination.pageSize,
                    }, () => {});
                    },
                )
                .catch((e) => {
                    let message = ''
                    if (taskIds.length > 1) {
                        message = this.$t('regular.errors.rejectReportsFailed') as string
                    } else {
                        message = this.$t('regular.errors.rejectReportFailed') as string
                    }
                    this.showError(message);
                });
        }

        sendTaskToFinalApproval(taskIds: number[]) {
          this.httpSendToFinalApprovalTasks(taskIds)
              .then((r) => {
                this.selectedReportsArray = [];
                this.showInfo(this.$t('regular.notifications.reportsSentToFinalApprover') as string);
                this.fetchList({
                  currentPage: this.pagination.current,
                  perPage: this.pagination.pageSize,
                }, () => {});
              })
              .catch((e) => {
                this.showError(
                    this.$t('regular.errors.sendToFinalApproverFailed') as string
                );
              });
        }

        approveTask(taskIds: number[]) {
            this.httpApproveTask(taskIds)
                .then((r) => {
                        this.checkApprovedReports();
                        if (taskIds.length > 1) {
                          this.selectedReportsArray = [];
                          this.showInfo(this.$t('regular.notifications.reportsApproved') as string);
                        } else {
                          this.showInfo(this.$t('regular.notifications.reportApproved') as string);
                        }
                        this.fetchList({
                            currentPage: this.pagination.current,
                            perPage: this.pagination.pageSize,
                        }, () => {});
                    },
                )
                .catch((e) => {
                    const status = e && e.response && e.response.status;
                    if (status === 409) {
                        this.showInfo(this.$t('regular.notifications.reportApprovalInProgress') as string);
                        return;
                    }
                    let message = ''
                    if (taskIds.length > 1) {
                        message = this.$t('regular.errors.approveReportsFailed') as string
                    } else {
                        message = this.$t('regular.errors.approveReportFailed') as string
                    }
                    this.showError(message);
                });
        }

        fetchList(ctx: any, callback: (items: any[]) => void) {
            this.loadingTable = true;
            const params: TaskParams = {
                size: ctx.perPage, page: ctx.currentPage - 1,
            };
            params.showOnlyRevaluationReports = true;

            const userFio = this.newSelectUserFio;
            if (userFio != null && userFio !== 'All') {
                params.userFio = userFio;
            }

            if (this.selectedStatusesFilter.length > 0) {
                params.statusList = [...this.selectedStatusesFilter];
            }

            const company = LocalData.zeroToNull(this.newSelectMarket);
            if (company != null) {
                params.tradingId = company;
            }

            const type = this.newSelectReportType;
            if (type != null) {
                params.type = type;
            }

            const group = LocalData.zeroToNull(this.newSelectGroup);
            if (group != null) {
                params.group = group;
            }

            const category = LocalData.zeroToNull(this.newCategoryOfProduct);
            if (category != null) {
                params.category = category;
            }

            const subCategory = LocalData.filterNumberArrays(this.subCategoryOfProduct, true);
            if (subCategory != null) {
                params.subcategories = subCategory.join(',');
            }

            const storeFormat = LocalData.zeroToNull(this.newSelectFormat);
            if (storeFormat != null) {
                params.storeFormat = storeFormat;
            }

            const region = LocalData.filterNumberArrays(this.selectRegion, true);
            if (region != null) {
                params.storeRegions = region.join(',');
            }

            const cluster = LocalData.zeroToNull(this.newSelectCluster);
            if (cluster != null) {
                params.storeCluster = cluster;
            }
            if (this.updatedDateRange.length > 0) {
                params.dateBefore = this.updatedDateRange[0]
                params.dateAfter = this.updatedDateRange[1]
            }

            const tableFilters: {
                taskIdsFilter?: number[];
                taskUpdateDateFilter?: number | null;
            } = {};

            if (this.tableFilterValues.taskIdsFilter) {
                tableFilters.taskIdsFilter = this.tableFilterValues.taskIdsFilter;
            }

            if (this.tableFilterValues.taskUpdateDateFilter) {
                tableFilters.taskUpdateDateFilter = Number(new Date(this.tableFilterValues.taskUpdateDateFilter));
            }

            let skipLoading = false;
            this.httpGetTaskList({
                  ...params,
                  ...tableFilters,
                }).then((response) => {
                    const { content, totalElements } = response.data;
                    const requestedPage = ctx.currentPage;
                    const emptyPage = content.length === 0;
                    const hasData = totalElements > 0;

                    if (requestedPage > 1 && emptyPage && hasData) {
                        skipLoading = true;
                        const pager = { ...this.pagination };
                        pager.current = 1;
                        pager.total = totalElements;
                        this.pagination = pager;
                        this.fetchList({
                            currentPage: 1,
                            perPage: ctx.perPage,
                        }, callback);
                        return;
                    }

                    const pagination = { ...this.pagination };
                    pagination.total = totalElements;
                    this.pagination = pagination;

                    this.table = content;
                    this.totalRows = totalElements;
                    callback(content);
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadReportListFailed') as string);
                    callback([]);
                })
                .finally(() => {
                    if (!skipLoading) {
                        this.loadingTable = false;
                    }
                });

            if (this.usersFioList.length === 0) {
                this.httpGetUsersFio()
                    .then((response) => {
                        this.usersFioList = response.data.map((i) => {
                            return {value: i, label: i}
                        });
                        this.usersFioList.unshift({value: 'All', label: this.$t('regular.common.all') as string});
                    })
                    .catch((e) => {
                        this.showError(this.$t('regular.errors.loadUserListFailed') as string);
                    });
            }

            this.httpGetAllReportsIds(params)
                .then((response) => {
                    this.tableFilterOptions.taskIds = response.data;
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadReportNumbersFailed') as string);
                });
        }

        fetchGlobalSettingsData() {
          this.httpGetGlobalSettings()
              .then((r) => {
                this.globalSettings = r.data;
              })
              .catch((ex) => {
                this.showError(this.$t('regular.errors.loadGlobalSettingsFailed') as string)
              })
        }

        applyFilters() {
            this.fetchList({
                currentPage: 1,
                perPage: this.pagination.pageSize,
            }, () => {});
        }

        // selectOrClearAllReports() {
        //     if (this.selectedReportsArray.length !== 0) {
        //         this.selectedReportsArray = []
        //     } else {
        //         this.selectedReportsArray = this.allReportsIds;
        //     }
        // }

        isSelectedTaskId(taskId: number) {
            const index = this.selectedReportsArray.findIndex((id) => {
                return id === taskId
            });
            return index !== -1;
        }

        setSelectedTaskId(taskId: number, selected: boolean) {
            const index = this.selectedReportsArray.findIndex((id) => {
                return id === taskId
            });
            if (selected) {
                if (index === -1) {
                    this.selectedReportsArray.push(taskId);
                }
            } else {
                if (index !== -1) {
                    this.selectedReportsArray.splice(index, 1);
                }
            }
        }

        loadTasksMarkets() {
            this.httpLoadTradingNetworks(true)
                .then((json) => {
                    this.items = json.data
                        .map((item) => {
                            return item;
                        })
                        .sort((a, b) => {
                            return a.id === b.id ? 0 : +(a.id > b.id) || -1;
                        })
                        .map((i) => {
                            return {value: i.id, label: i.tradingName};
                        });

                    this.items = [{
                      value: -1,
                      label: this.$t('regular.common.allTypo') as string,
                    }, ...this.items];
                    this.$log.debug(this.items);

                })
                .catch((err) => {
                });
        }

        clearFilters() {
            this.selectedStatusesFilter = [];
            this.newSelectReportType = null;
            this.newSelectMarket = this.defaultFilterValue.value;
            this.newSelectGroup = this.defaultFilterValue.value;
            this.newCategoryOfProduct = this.defaultFilterValue.value;
            this.subCategoryOfProduct = [];
            this.newSelectFormat = this.defaultFilterValue.value;
            this.selectRegion = [];
            this.newSelectCluster = this.defaultFilterValue.value;
            this.categoryOptions = [this.defaultFilterValue];
            this.subCategoryOptions = this.defaultMultipleValue;
            this.formatOptions = this.defaultMultipleValue;
            this.regionOptions = this.defaultMultipleValue;
            this.clusterOptions = this.defaultMultipleValue;
            this.newSelectUserFio = 'All';
            this.updatedDateRange = [];

            const pager = { ...this.pagination };
            pager.current = 1;
            this.pagination = pager;
            this.fetchList({
                currentPage: this.pagination.current,
                perPage: this.pagination.pageSize,
            }, () => {})
        }

        resetByGroup() {
            this.resetData(TaskInfoFilterType.group)
        }

        resetByCategory() {
            this.resetData(TaskInfoFilterType.category)
        }

        resetByStoreFormat() {
            this.resetData(TaskInfoFilterType.format)
        }

        resetByStoreCluster() {
            this.resetData(TaskInfoFilterType.cluster)
        }

        updateSubcategories(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.subCategoryOfProduct)) {
                this.subCategoryOfProduct = list;
                this.resetBySubcategory();
            } else if (this.subCategoryOfProduct[0] === 0) {
                this.subCategoryOfProduct = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        updateRegions(list: number[]) {
            if (list.length > 0 && !LocalData.compareTwoArrays(list, this.selectRegion)) {
                this.selectRegion = list;
                this.resetByStoreRegion();
            } else if (this.selectRegion[0] === 0) {
                this.selectRegion = this.defaultIntSelectBox.map((i) => i.value);
            }
        }

        showApproveButton(task: TaskData): boolean {
          if (task.status === TaskStatus.APPROVED) {
            return false;
          }

          // Если двухэтапное согласование включено и отчет отправлен на финальное утверждение,
          // то показываем специальную кнопку финального утверждения, а не обычную
          return !(this.isTwoStepApprovalEnabled && task.status === TaskStatus.SENT_TO_FINAL_APPROVAL);
        }

        showFinalApproveButton(item: TaskData): boolean {
          if (!this.isTwoStepApprovalEnabled) {
            return false;
          }

          return item.status === TaskStatus.SENT_TO_FINAL_APPROVAL
              && this.canFinalApproveOrReject();
        }

        canBeShown(task: TaskData): boolean {
            if (!taskTypesRequiresConfirmation.map((entry) => entry.value).includes(task.typeMachine)) {
                return false;
            }
            return task.status === 'WriteToFileComplete' || 
                   task.status === 'OnApproval' ||
                   task.status === 'SentToFinalApproval' ||
                   task.status === 'Rejected' || 
                   task.status === 'Approved' || 
                   task.status === 'PartiallyApproved' || 
                   task.status === 'PartiallyRejected';
        }

        selectResult(task: TaskData) {
            let subCategories = ' - ';
            if (task.subcategories.length > 0) {
                subCategories = task.subcategories + ' / '
            }

            let formatName = ' - ';
            if (task.format !== '') {
                formatName = task.format + ' / '
            }

            let regionName = ' - ';
            if (task.region !== '') {
                regionName = task.region + ' / '
            }

            let clusterName = ' - ';
            if (task.cluster !== '') {
                clusterName = task.cluster + ' / '
            }
            const filters = task.group + ' / ' + task.category + ' / ' + subCategories + formatName + regionName + clusterName
            this.taskToView = {
                id: task.id,
                status: task.status,
                type: task.typeMachine,
                fileResult: task.fileResult,
                editable: task.editable,
                filterNames: filters,
            };
            // (this.$refs.resultViewTab as any).disabled = false;
            // (this.$refs.resultViewTab as any).activate();
            this.currentMainTab = "resultViewTab"
        }

        selectPackageResult(task: ResultTableHeaders) {
            let subCategories = ' - ';
            if (task.subCategoryName !== '') {
                subCategories = task.subCategoryName + ' / '
            }

            let formatName = ' - ';
            if (task.formatName !== '') {
                formatName = task.formatName + ' / '
            }

            let regionName = ' - ';
            if (task.regionName !== '') {
                regionName = task.regionName + ' / '
            }

            let clusterName = ' - ';
            if (task.clusterName !== '') {
                clusterName = task.clusterName + ' / '
            }
            const filters = task.groupName + ' / ' + task.categoryName + ' / ' + subCategories + formatName + regionName + clusterName
            this.packageSubtask = {
                id: task.taskId,
                status: task.status,
                type: task.type,
                fileResult: task.fileResult,
                editable: task.editable,
                filterNames: filters,
            };
            // (this.$refs.resultPackageViewTab as any).disabled = false;
            // (this.$refs.resultPackageViewTab as any).activate();
            this.currentMainTab = "resultPackageViewTab"
        }

        refreshTable(isAutoRefresh?: boolean) {
            this.loadingTable = true;
            this.pagination = {...this.pagination};

            if (!isAutoRefresh || (isAutoRefresh && this.currentMainTab === 'listViewTab')) {
                this.fetchList({
                    currentPage: this.pagination.current,
                    perPage: this.pagination.pageSize,
                }, () => {});
            }
        }

        startAutoRefreshTable() {
          this.refreshTableIntervalId = setInterval(() => {
              this.refreshTable(true);
          }, 10000);
        }

        getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
            return {
                type: taskType,
                // tslint:disable-next-line: no-non-null-assertion
                tradingId: this.newSelectMarket!!,
                categories: LocalData.filterNumberArrays([this.newCategoryOfProduct], true),
                groups: LocalData.filterNumberArrays([this.newSelectGroup], true),
                subcategory: LocalData.filterNumberArrays(this.subCategoryOfProduct, true),
                segments: null,
                storeFormat: LocalData.filterNumberArrays([this.newSelectFormat], true),
                storeCluster: LocalData.filterNumberArrays([this.newSelectCluster], true),
                storeRegion: LocalData.filterNumberArrays(this.selectRegion, true),
                byReports: true,
            }
        }

        resetBySubcategory() {
            this.resetData(TaskInfoFilterType.subcategory)
        }

        resetByStoreRegion() {
            this.resetData(TaskInfoFilterType.region)
        }

        resetData(type: TaskInfoFilterType | null = null) {
            switch (type) {
                case null:
                    this.newSelectGroup = this.defaultFilterValue.value;
                    this.newCategoryOfProduct = this.defaultFilterValue.value;
                    this.subCategoryOfProduct = [];
                    this.newSelectFormat = this.defaultFilterValue.value;
                    this.selectRegion = [];
                    this.newSelectCluster = this.defaultFilterValue.value;
                    this.groupOptions = this.defaultMultipleValue;
                    this.categoryOptions = [this.defaultFilterValue];
                    this.subCategoryOptions = this.defaultMultipleValue;
                    this.formatOptions = this.defaultMultipleValue;
                    this.regionOptions = this.defaultMultipleValue;
                    this.clusterOptions = this.defaultMultipleValue;
                    break;
                case TaskInfoFilterType.group:
                    this.newCategoryOfProduct = this.defaultFilterValue.value;
                    this.subCategoryOfProduct = [];
                    this.newSelectFormat = this.defaultFilterValue.value;
                    this.selectRegion = [];
                    this.newSelectCluster = this.defaultFilterValue.value;
                    this.categoryOptions = [this.defaultFilterValue];
                    this.subCategoryOptions = this.defaultMultipleValue;
                    this.formatOptions = this.defaultMultipleValue;
                    this.regionOptions = this.defaultMultipleValue;
                    this.clusterOptions = this.defaultMultipleValue;
                    this.getCategoryInfo();
                    this.getSubcategoryInfo();
                    this.getStoreFormatsInfo();
                    this.getStoreRegionsInfo();
                    this.getStoreClustersInfo();
                    break;
                case TaskInfoFilterType.category:
                    this.subCategoryOfProduct = [];
                    this.newSelectFormat = this.defaultFilterValue.value;
                    this.selectRegion = [];
                    this.selectCluster = this.defaultFilterValue;
                    this.subCategoryOptions = this.defaultMultipleValue;
                    this.formatOptions = this.defaultMultipleValue;
                    this.regionOptions = this.defaultMultipleValue;
                    this.clusterOptions = this.defaultMultipleValue;
                    this.getSubcategoryInfo();
                    this.getStoreFormatsInfo();
                    this.getStoreRegionsInfo();
                    this.getStoreClustersInfo();
                    break;
                case TaskInfoFilterType.subcategory:
                    this.selectFormat = this.defaultFilterValue;
                    this.selectRegion = [];
                    this.newSelectCluster = this.defaultFilterValue.value;
                    this.formatOptions = this.defaultMultipleValue;
                    this.regionOptions = this.defaultMultipleValue;
                    this.clusterOptions = this.defaultMultipleValue;
                    this.getStoreFormatsInfo();
                    this.getStoreRegionsInfo();
                    this.getStoreClustersInfo();
                    break;
                case TaskInfoFilterType.format:
                    this.selectRegion = [];
                    this.newSelectCluster = this.defaultFilterValue.value;
                    this.regionOptions = this.defaultMultipleValue;
                    this.clusterOptions = this.defaultMultipleValue;
                    this.getStoreRegionsInfo();
                    this.getStoreClustersInfo();
                    break;
                case TaskInfoFilterType.region:
                    this.newSelectCluster = this.defaultFilterValue.value;
                    this.clusterOptions = this.defaultMultipleValue;
                    this.getStoreClustersInfo();
                    break;
            }
        }

        handleReportListFilter() {
          this.refreshTable()
          if (LocalData.zeroToNull(this.newSelectMarket) != null) {
            this.loadReportListFilterOptions()
          }
        }

        async loadReportListFilterOptions() {
          try {
            await Promise.all([
              this.getGroupInfo(),
              this.getCategoryInfo(),
              this.getSubcategoryInfo(),
              this.getStoreFormatsInfo(),
              this.getStoreRegionsInfo(),
              this.getStoreClustersInfo(),
            ]);
          } catch (e) {
          }
        }

        getGroupInfo() {
            return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
                .then((data) => {
                    const filterData = data.data;
                    this.groupOptions = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.groupOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue);
                })
                .catch((e) => {
                })
        }

        getCategoryInfo() {
            return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
                .then((data) => {
                    const filterData = data.data;
                    this.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.categoryOptions.unshift(this.defaultFilterValue);
                })
                .catch((e) => {
                })
        }

        getSubcategoryInfo() {
            return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
                .then((data) => {
                    const filterData = data.data;
                    this.subCategoryOptions = filterData.subcategories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.subCategoryOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
        }

        getStoreFormatsInfo() {
            return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    this.formatOptions = filterData.storeFormat.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.formatOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
        }

        getStoreRegionsInfo() {
            return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                .then((data) => {
                    const filterData = data.data;
                    this.regionOptions = filterData.storeRegion.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.regionOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
        }

        getStoreClustersInfo() {
            return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                .then((data) => {
                    const filterData = data.data;
                    this.clusterOptions = filterData.storeCluster.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.clusterOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
        }

        checkMajorPriceChangeInRevaluation() {
          this.waitingToBeSentToFtp = true
          this.httpCheckMajorPriceChangeInRevaluation(this.selectedTradings)
              .then((resp) => {
                const foundMajorPriceChangeInRevaluation = resp.data
                if(foundMajorPriceChangeInRevaluation) {
                  this.showMajorPriceDiffModal = true
                }
                else {
                  this.manualSendApprovedTasksToFtp()
                }
              })
              .catch((e) => {
                this.showError(this.$t('regular.errors.checkRevaluationPriceChangeFailed') as string + e.response.data.message);
                this.waitingToBeSentToFtp = false
              });
        }

        manualSendApprovedTasksToFtp() {
          this.waitingToBeSentToFtp = true

          this.httpManualSendApprovedRevaluationsToFtp(this.selectedTradings)
              .then((resp) => {
                if (resp.status === 204) {
                  this.showInfo(this.$t('regular.notifications.noProductsForExport') as string)
                } else {
                  const sentCount = resp && resp.data && resp.data.sentCount
                  this.showInfo(
                      this.$t('regular.notifications.quotaProductsSentToFtp') as string +
                      (Number.isFinite(sentCount) ? ': ' + sentCount : '')
                  )
                }

                this.waitingToBeSentToFtp = false
              })
              .catch((e) => {
                const msg =
                    (e &&
                        e.response &&
                        e.response.data &&
                        (e.response.data.message || e.response.data.error)) ||
                    e.message ||
                    e
                this.showError(this.$t('regular.errors.sendFilesToFtpFailed') as string + msg)
                this.waitingToBeSentToFtp = false
              })
        }

        abortSendingToFtp() {
          this.waitingToBeSentToFtp = false
        }

        onMajorPriceChangeModalHide(bvEvent: BvModalEvent) {
          if (bvEvent.trigger === 'headerclose') {
            this.abortSendingToFtp();
          }
        }

        checkApprovedReports() {
            this.httpCheckApprovedRevaluationsTasks()
                .then((resp) => {
                        this.foundedApprovedReports = resp.data
                    },
                )
                .catch((e) => {
                    this.showError(this.$t('regular.errors.checkApprovedReportsFailed') as string);
                    this.foundedApprovedReports = false
                });
        }

        loadAllTradingNames() {
            this.httpLoadTradingNetworks()
                    .then((result) => {
                                result.data.forEach((value) => {
                                    this.tradingsList.push({value: value.id, label: value.tradingName})
                                    this.selectedTradings.push(value)
                                });
                            },
                    )
                    .catch((e) => {
                        this.showError(this.$t('regular.errors.loadTradingCompaniesFailedNoDot') as string);
                    });
        }

        showUploadPricing() {
            this.showUploadPricingModal = true;
        }

        showUploadSales() {
            this.showUploadSalesModal = true;
        }

        manualSendPackageSalesToFtp() {
            this.waitingToBeSentSalesToFtp = true;
            this.httpManualSendPackageSalesToFtp(this.selectedTradings)
                .then((resp) => {
                    if (resp.data.statusCodeValue !== 200) {
                        this.showInfo(this.$t('regular.notifications.noDataForSalesExport') as string);
                    } else {
                        this.showInfo(this.$t('regular.notifications.salesDataSentToFtp') as string);
                    }
                    this.waitingToBeSentSalesToFtp = false;
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.sendSalesDataToFtpFailed') as string + e.response.data.message);
                    this.waitingToBeSentSalesToFtp = false;
                });
        }

        isSelectedTrading(tradingId: number): boolean {
            const index = this.selectedTradings.findIndex((item) => {
                return item.id === tradingId
            });
            return index !== -1;
        }

        isAdminAdmin(): boolean {
          return this.currentUserId === 1;
        }

        isFinalApprover(): boolean {
          return !!this.$additionalRoles && this.$additionalRoles.includes(AdditionalRole.FINAL_APPROVER);
        }

        canFinalApproveOrReject(): boolean {
          return this.isAdminAdmin() || this.isFinalApprover();
        }

        setSelectedTrading(trading: SelectBox<number>, change: boolean) {
            if (change) {
                this.selectedTradings.push({id: trading.value, tradingName: trading.label, isDefault: false})
            } else {
                const index = this.selectedTradings.findIndex((item) => {
                    return item.id === trading.value
                });
                if (index !== -1) {
                    this.selectedTradings.splice(index, 1)
                }
            }
        }

        selectOrClearAllTradings() {
            if (this.selectedTradings.length !== 0) {
                this.selectedTradings = []
            } else {
                this.selectedTradings = this.tradingsList.map((trading) => {
                    return {id: trading.value, tradingName: trading.label, isDefault: false}
                });
            }
        }

        handleFilterAllCheckboxChanged(value: boolean, filterModel: 'taskIdsFilter', filterOptionsKey: string, useRange: boolean = false) {
            this.filterAllCheckboxCheckedState[filterModel] = value;

            if (value) {
                this.tableFilterValues[filterModel] = [
                    ...new Set([
                        ...(this.tableFilterValues[filterModel] as number[] || []),
                        ...(this.getFilterOptions(filterModel, filterOptionsKey, useRange) as Array<number>),
                    ])
                ];
            } else {
                const optionValuesToDeselect = (this.getFilterOptions(filterModel, filterOptionsKey, useRange) as Array<number>);

                this.tableFilterValues[filterModel] = (this.tableFilterValues[filterModel] as number[] || []).filter((value: number) => !optionValuesToDeselect.includes(value));
            }
        }

        getFilterOptions(filterModel: string, filterOptionsKey: string, useRange: boolean = false) {
            if (useRange) {
                return this.tableFilterOptions[filterOptionsKey].filter((value: number) => {
                    if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && !(this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                        return value >= this.filterDropdownsRange.from[filterModel];
                    } else if (!(this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                        return value <= this.filterDropdownsRange.to[filterModel];
                    } else if ((this.filterDropdownsRange.from[filterModel] || this.filterDropdownsRange.from[filterModel] === 0) && (this.filterDropdownsRange.to[filterModel] || this.filterDropdownsRange.to[filterModel] === 0)) {
                        return this.filterDropdownsRange.from[filterModel] <= value && value <= this.filterDropdownsRange.to[filterModel];
                    } else {
                        return true;
                    }
                })
            } else {
                return this.tableFilterOptions[filterOptionsKey];
            }
        }

        getCheckboxFilterOptions(filterModel: string, filterOptionsKey: string, useRange: boolean = false) {
            const allOptions = this.getFilterOptions(filterModel, filterOptionsKey, useRange);

            this.taskIdsCommonCount = allOptions.length;

            if (allOptions.length > this.taskIdsMaxViewCount) {
                this.taskIdsDisplayedCount = this.taskIdsMaxViewCount;

                return allOptions.slice(0, this.taskIdsMaxViewCount).map((taskId: number) => ({ label: String(taskId), value: taskId }));
            } else {
                this.taskIdsDisplayedCount = this.taskIdsCommonCount;

                return allOptions.map((taskId: number) => ({ label: String(taskId), value: taskId }));
            }
        }

        get isAllStatusesSelected(): boolean {
            const opts = this.statusFilterCheckboxOptions;
            return opts.length > 0 && this.selectedStatusesFilter.length === opts.length;
        }

        onAllStatusesCheckboxChange(e: any) {
          this.selectedStatusesFilter = e.target.checked
              ? this.statusFilterCheckboxOptions.map((o) => o.value)
              : [];
        }

        get isTwoStepApprovalEnabled(): boolean {
          return this.globalSettings.useTwoStepRevaluationApproval;
        }

        get currentUserId(): number | null {
          const auth = localStorage.getItem('AUTH');
          if (!auth) return null;

          try {
            const { user_id } = JSON.parse(auth);
            return typeof user_id === 'number' ? user_id : null;
          } catch {
            return null;
          }
        }

        get approveCheckedReportsPrompt(): string {
          return this.isTwoStepApprovalEnabled
              ? this.$t('regular.confirm.sendForFinalApproval') as string
              : this.$t('regular.confirm.approveSelectedTasks') as string;
        }

        get approveCheckedReportsModalTitle(): string {
          return this.isTwoStepApprovalEnabled
              ? this.$t('regular.notifications.finalReportsApproval') as string
              : this.$t('regular.notifications.reportsApproval') as string;
        }

    }
